import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colors from '../../styles/colors';
import { STATIC_HOMEPAGE_URL } from '../../config';

const TermsAgreement = (props = {}) => {
  const handleChange = () => {
    const { accepted } = props;
    props.onChange(!accepted);
  };

  return (
    <Label id="accept" className="font-weight-400">
      <input
        type="checkbox"
        className="no-margin"
        defaultChecked={props.accepted}
        onClick={handleChange}
        htmlFor="accept"
      />
      <span className="margin-two-left text-small">
        I accept the{' '}
        <a href={`${STATIC_HOMEPAGE_URL}/terms`} target="_blank">
          terms of use
        </a>{' '}
        and{' '}
        <a href={`${STATIC_HOMEPAGE_URL}/privacy`} target="_blank">
          privacy policy
        </a>
        .
      </span>
    </Label>
  );
};

const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;

  input[type='checkbox'] {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }

  a {
    color: ${Colors.mainOrange};

    &:hover {
      text-decoration: underline;
    }
  }
`;

TermsAgreement.propTypes = {
  accepted: PropTypes.bool,
  onChange: PropTypes.func,
};

TermsAgreement.defaultProps = {
  accepted: true,
  onChange: () => {},
};

export default TermsAgreement;
